import { isRasterLayerAnnotation } from '@/composables/useEditorV2/useConnectStore/resolveRasterMapping'
import type { V2AnnotationPayload } from '@/store/types'

export const filterToRasterLayerAnnotationsOnly = (
  annotations: V2AnnotationPayload[],
): V2AnnotationPayload[] => annotations.filter(isRasterLayerAnnotation)

export const findDefaultRasterLayer = (
  annotations: V2AnnotationPayload[],
): V2AnnotationPayload | undefined => annotations.find(isRasterLayerAnnotation)

/**
 * Removes the workflow raster layer that the BE copied into the default group:
 * the default raster's `source_annotation_id` points at the original workflow raster's id.
 */
export const omitWorkflowRasterLayerCopiedToDefault = (
  defaultAnnotations: V2AnnotationPayload[],
  workflowRasterLayers: V2AnnotationPayload[],
): V2AnnotationPayload[] => {
  const defaultRasterLayer = findDefaultRasterLayer(defaultAnnotations)
  const sourceId = defaultRasterLayer?.source_annotation_id
  if (!sourceId) return workflowRasterLayers
  return workflowRasterLayers.filter((ann) => ann.id !== sourceId)
}
